import React from "react"
import { observer, inject } from "mobx-react"



const Search = observer(props => {
  const { search } = props.shop;
  const { searchPartGroupsByPartNumber } = props.shop.partGroupStore

  const handleOnChange =  async e => {
    const searchResults = [];
    search.setSearchTerm(e.target.value);
    
    const partsGroupsFound = await searchPartGroupsByPartNumber(e.target.value);

    partsGroupsFound.forEach((partGroup) => {
      searchResults.push({
        title: partGroup[1].name,
        image: "/images/partGroups/" + partGroup[1].imgSrc,
        urlname: partGroup[1].urlName
      });
    });

    search.setResults(searchResults);
  };

  const handleOnFocus = () => {
    search.setIsFocused(true);
  };

  const handleOnBlur = (e) => {
    if (e.relatedTarget == null || e.relatedTarget.getAttribute("class") !== 'result')
      search.setIsFocused(false);
  };

  const handleOnClick = result => {
    search.setIsFocused(false);
    const { openPartGroupPageByUrlName } = props.shop.view;
    const { shop } = props;
    shop.setLastSelectedSearch('');
    shop.setLastSelectedSearch(search.searchTerm);
    openPartGroupPageByUrlName(result.urlname);
      
  }

  const renderResults = () => {
    const output = [];

    search.results.forEach(result => {
      output.push(
        <div id={result.urlname} tabIndex="-1" urlname={result.urlname} className="result" onClick={(e) => { handleOnClick(result);}}>
          <div className="image"><img src={result.image} /></div>
          <div className="content">
            <div className="title">{result.title}</div>
          </div>
      </div>
      );
    });

    return output;
  };


  return (
    <div className="right item partSearch">
      <div shop="ShopStore@&lt;root&gt;" className={'ui search' + (search.isFocused ? ' focus' : '')}>
        <div className="ui icon input">
          <input placeholder="Part Search..." autocomplete="off" type="text" tabindex="0" className="prompt" value={search.searchTerm} onChange={handleOnChange} onFocus={handleOnFocus} onBlur={handleOnBlur} />
          <i aria-hidden="true" className="search icon"></i>
        </div>
        <div className={'results transition' + (search.showResults ? ' visible' : '')}> 
          {search.results.length < 1 && <div className="message empty">
            <div className="header">No results found.</div>
          </div>}
          {renderResults()}
        </div>
      </div>
    </div>
  )
});


// results transition visible
export default inject("shop")(Search);
